import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  content: {
    height: '100%',

    [theme.breakpoints.up('lg')]: {
      paddingTop: 10,
    },
  },
}));

export default useStyles;
